module.exports = __webpack_public_path__ + "static/izhar-21cc3548da62e32da01a0e61d9902b08.png";